var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.type || 'button',_vm._g({tag:"component",class:[
		'el-button',
		_vm.variantClass,
		_vm.disabled ? '-disabled' : null ],attrs:{"disabled":_vm.disabled,"href":_vm.href,"target":_vm.target}},_vm.$listeners),[_c('span',{staticClass:"button-text",domProps:{"innerHTML":_vm._s(_vm.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }